import CrownIcon from "@/assets/dark_gradient/crown.svg?react";
import Modal from "@/components/Common/Modal";
import AmbassadorProgramContent from "@/components/Common/referral/AmbassadorProgramContent";
import {ambassadorProgramModalAtom, inviteAmbassadorsModalAtom} from "@/store/jotaiAtoms";
import type {TReferralTab} from "@/store/types";
import {useAtom, useSetAtom} from "jotai";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const AmbassadorProgramModal: FC = () => {
  const {t} = useTranslation("referral");
  const [ambassadorProgramModal, setAmbassadorProgramModal] = useAtom(ambassadorProgramModalAtom);
  const setInviteAmbassadorsModal = useSetAtom(inviteAmbassadorsModalAtom);

  const openInviteModal = (section: TReferralTab) => {
    const {agencyId, companyId} = ambassadorProgramModal;
    setAmbassadorProgramModal(state => {
      state.agencyId = null;
      state.companyId = null;
      state.isOpen = false;
    });
    setInviteAmbassadorsModal(state => {
      state.agencyId = agencyId;
      state.companyId = companyId;
      state.isOpen = true;
      state.openedFromAmbassadorProgram = true;
      state.section = section;
    });
  };

  return (
    <Modal
      className="max-h-[90vh] p-5 sm:p-10"
      backgroundClassName="max-w-160"
      customTitleRow={
        <div className="flex items-center gap-3 p-5">
          <CrownIcon className="size-4 shrink-0" />
          <span className="text-neutral-black text-xl font-semibold">{t("ambassador_program")}</span>
        </div>
      }
      onClose={() =>
        setAmbassadorProgramModal(state => {
          state.agencyId = null;
          state.companyId = null;
          state.isOpen = false;
        })
      }
      customBottomRow={<></>}
      shouldLockBodyScroll={false}>
      <AmbassadorProgramContent agencyId={ambassadorProgramModal.agencyId} onSelect={openInviteModal} />
    </Modal>
  );
};

export default AmbassadorProgramModal;
